import React, { useEffect, FC } from 'react';
import { render } from 'react-dom';
import { createGlobalStyle, useTheme } from 'styled-components';

const globalStyles = new Map<string, JSX.Element>();
let element: undefined | HTMLDivElement;

const ensureElementReady = () => {
  if (!element) {
    if (global.document) {
      element = global.document.createElement('div');
      global.document.head.appendChild(element);
    } else {
      console.warn('No document to render global styles', global.document);
    }
  }
};

const useDedupedStyleRendering = (key: string, styleElement: JSX.Element) => {
  const shouldUpdateStyles = !globalStyles.has(key);
  if (shouldUpdateStyles) {
    globalStyles.set(key, styleElement);
  }

  useEffect(() => {
    if (shouldUpdateStyles && element) {
      const list = Array.from(globalStyles).map((entry) => entry[1]);
      render(<>{list}</>, element);
    }
  }, [shouldUpdateStyles]);
};

interface DedupedGlobalStyle {
  id: string;
}

type CreateGlobalStyleParams = Parameters<typeof createGlobalStyle>;
function createDedupedGlobalStyle(first: CreateGlobalStyleParams['0'], ...interpolations: CreateGlobalStyleParams['0'][]): FC<DedupedGlobalStyle> {
  const GlobalStyle = createGlobalStyle(first, ...interpolations);
  return ({ id }) => {
    const theme = useTheme();
    ensureElementReady();
    useDedupedStyleRendering(id, <GlobalStyle key={id} theme={theme} />);
    return null;
  };
}
// name should be the same, otherwise IDE will not see the template string as styles
export { createDedupedGlobalStyle as createGlobalStyle };
